"use client";
import { RouteError } from "@/components/RouteError";

export default function AssetDetailError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      error={error}
      reset={reset}
      label="ASSET ERROR"
      backHref="/browse"
      backLabel="Back to Browse"
    />
  );
}
